// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qo-2";
export var chatLink = "_qo-0";
export var chatText = "_qo-1";